import { render, staticRenderFns } from "./MobilePreventionEnvironmentRequestUpdate.vue?vue&type=template&id=15c9521a&scoped=true&"
import script from "./MobilePreventionEnvironmentRequestUpdate.vue?vue&type=script&lang=js&"
export * from "./MobilePreventionEnvironmentRequestUpdate.vue?vue&type=script&lang=js&"
import style0 from "./MobilePreventionEnvironmentRequestUpdate.vue?vue&type=style&index=0&id=15c9521a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c9521a",
  null
  
)

export default component.exports